module.exports = __webpack_public_path__ + "img/middle_8.3230dbb7.png";